import React, { Component } from "react";
import {
  withStyles,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from "@material-ui/core";
import clsx from "clsx";
import { Skeleton } from "@material-ui/lab";
import axios from "axios";
import { URL } from "../../config/config";
import { Edit, Delete, Visibility, VisibilityOff } from "@material-ui/icons";
import { Link } from "react-router-dom";
import FlowLibraryDetails from "./FlowLibraryDetails";
import { isValidUrl } from "../../helpers/url";
import { SnackbarContext } from "../../commons/Snackbar/Snackbar";

let fields = [
  {
    name: "Flow Id",
    key: "_id",
  },
  {
    name: "Flow Name",
    key: "flowName",
  },
  {
    name: "Project Id",
    key: "assistantId",
  },
  {
    name: "Tags",
    key: "tags",
  },
  {
    name: "Created At",
    key: "createdAt",
  },
  {
    name: "Action",
    key: "action",
  },
];

function getRandomColor() {
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

const quickFilters = [
  "Last active - 24 hr window",
  "Created - This week",
  "Created - This month",
];

class FlowLibraryTable extends Component {
  static contextType = SnackbarContext;
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      openDeleteDialog: false,
      openVisibilityDialog: false,
      selectedFlow: null,
      alert: "",
      alertMessage: "",
    };
  }

  toggleDialog = () => {
    this.setState({ openDialog: !this.state.openDialog });
  };

  openTemplate = (index) => {
    this.setState({ openDialog: true, selectedFlow: index });
  };

  deleteFlow = () => {
    const { removeFlow, flows } = this.props;
    const currFlow = flows[this.state.selectedFlow];
    axios
      .post(URL + "/superadmin/update-flow-library", {
        flowId: flows[this.state.selectedFlow]._id,
        flowObject: { ...currFlow, isDeleted: true },
        assistantId: currFlow.assistantId,
      })
      .then(() => {
        removeFlow(this.state.selectedFlow);
        this.handleDeleteClose();
      })
      .catch((error) => {
        this.handleDeleteClose();
        console.log(error);
      });
  };

  validateFlow = (flow) => {
    if (!flow.flowName) {
      return { valid: false, msg: "Flow Name is required" };
    }
    if (!flow.subtitle) {
      return { valid: false, msg: "Flow Subtitle is required" };
    }
    if (!flow.impactPercentage) {
      return { valid: false, msg: "Impact Percentage is required" };
    }

    if (!Array.isArray(flow.categories) || flow.categories.length === 0) {
      return { valid: false, msg: "Categories field is required" };
    }

    if (!flow.bannerColor) {
      return { valid: false, msg: "Banner Color is required" };
    }

    if (!flow.videoLink) {
      return { valid: false, msg: "Video Link is required" };
    }

    if (!isValidUrl(flow.videoLink)) {
      return { valid: false, msg: "Invalid Video Link Url" };
    }

    for (let highlight of flow.outcomeHighlights) {
      if (!highlight.icon || !highlight.description) {
        return {
          valid: false,
          msg: "All fields in outcome highlights are mandatory",
        };
      }
    }

    if (!flow.flowDescription) {
      return { valid: false, msg: "Flow Description is required" };
    }

    if (!flow.tags) {
      return { valid: false, msg: "Invalid Flow tags" };
    }

    return { valid: true, msg: "All fields are validated" };
  };

  handleDeleteOpen = (flowIndex) =>
    this.setState({ selectedFlow: flowIndex, openDeleteDialog: true });
  handleDeleteClose = () =>
    this.setState({ selectedFlow: null, openDeleteDialog: false });

  updateCurrentFlow = (flowObject) => {
    const { updateFlow, flows } = this.props;
    const currFlow = flows[this.state.selectedFlow];

    axios
      .post(URL + "/superadmin/update-flow-library", {
        flowId: flows[this.state.selectedFlow]._id,
        flowObject: { ...currFlow, ...flowObject },
        assistantId: currFlow.assistantId,
      })
      .then(() => {
        updateFlow(this.state.selectedFlow, flowObject);
        this.handleUpdateClose();
      })
      .catch((error) => {
        this.handleUpdateClose();
        console.log(error);
      });
  };

  handleUpdateOpen = (flowIndex) =>
    this.setState({
      selectedFlow: flowIndex,
      openVisibilityDialog: true,
    });

  handleUpdateClose = () =>
    this.setState({ selectedFlow: null, openVisibilityDialog: false });

  render() {
    const { classes, flows, isLoading, hasWritePermission } = this.props;
    const fullScreen = window.innerWidth < 767 ? true : false;
    return (
      <div className={classes.root}>
        <table>
          <tbody>
            <tr className={`${classes.row} ${classes.topbar}`}>
              {fields.map((field) => (
                <th
                  className={clsx(classes.column, classes.dataColumn)}
                  style={{
                    justifyContent: field.name === "Action" ? "center" : "left",
                  }}
                >
                  <Typography variant="h5" color="primary">
                    {field.name}
                  </Typography>
                </th>
              ))}
            </tr>
            {!isLoading ? (
              <React.Fragment>
                {flows.map((e, index) => (
                  <tr
                    className={clsx(classes.row, classes.clickable, {
                      [classes.alterRow]: index % 2 == 0,
                    })}
                    onClick={() => this.openTemplate(index)}
                  >
                    {fields.map((field) => (
                      <th className={clsx(classes.column, classes.dataColumn)}>
                        {columnType(
                          classes,
                          e,
                          field,
                          index,
                          this.handleDeleteOpen,
                          this.handleUpdateOpen,
                          hasWritePermission,
                          this.props.flowLibraryCategories
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {[1, 2, 3, 4].map((e, index) => (
                  <tr className={clsx(classes.row)}>
                    {fields.map((field) => (
                      <th className={clsx(classes.column, classes.dataColumn)}>
                        <Skeleton style={{ width: "100%" }} height={40} />
                      </th>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            )}
          </tbody>
        </table>
        {/* Preview dialog */}
        <Dialog
          open={this.state.openDialog}
          onClose={this.toggleDialog}
          aria-labelledby="form-dialog-title"
          maxWidth="md"
          fullScreen={fullScreen}
        >
          {/* Flow Library Details */}
          <FlowLibraryDetails
            flowLibraryCategories={this.props.flowLibraryCategories}
            flowIndex={this.state.selectedFlow}
            flows={this.props.flows}
            toggleDialog={this.toggleDialog}
            hasWritePermission={hasWritePermission}
          />
        </Dialog>
        {/* Delete dialog */}
        <Dialog
          open={this.state.openDeleteDialog}
          onClose={this.handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Delete template</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this flow from flow library?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteClose}>Cancel</Button>
            <Button onClick={this.deleteFlow} autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        {/* visibility dialog */}
        {this.state.selectedFlow != null && (
          <Dialog
            open={this.state.openVisibilityDialog}
            onClose={this.handleUpdateClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Toggle Visibility</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {flows[this.state.selectedFlow].isVisible
                  ? "Are you sure that you want to disable the visibility of this flow? The flow will not be visible to customers"
                  : "Are you sure that you want to enable the visibility of this flow? The flow will be visible to customers"}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleUpdateClose}>Cancel</Button>
              <Button
                onClick={() => {
                  const currFlow = flows[this.state.selectedFlow];
                  const visibility = currFlow.isVisible;
                  const result = this.validateFlow(currFlow);

                  if (result.valid || visibility) {
                    this.updateCurrentFlow({
                      isVisible: !visibility,
                    });
                  } else {
                    this.context.showSnackbar(result.msg, "warning");
                    this.handleUpdateClose();
                  }
                }}
                autoFocus
              >
                {flows[this.state.selectedFlow].isVisible
                  ? "Disable"
                  : "Enable"}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    );
  }
}

const COLORS = {
  PENDING: "grey",
  APPROVED: "green",
  REJECTED: "red",
  PAUSED: "rgb(229, 148, 0)",
  PENDING_DELETION: "rgb(255, 127, 0)",
  DISABLED: "darkslategrey",
};

function getFormattedDate(date) {
  const d = new Date(date);
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date ? d.toLocaleDateString("en-US", options) : "";
}

function columnType(
  classes,
  columnData,
  field,
  flowIndex,
  handleDeleteOpen,
  handleUpdateOpen,
  hasWritePermission,
  flowLibraryCategories
) {
  const key = field.key;
  switch (key) {
    case "action":
      return (
        <fieldset
          disabled={!hasWritePermission}
          style={{ border: "none", padding: 0, margin: 0 }}
        >
          <Box
            width="100%"
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <IconButton
              component={Link}
              to={{
                pathname: "/flow-library/create",
                state: { flow: columnData, flowLibraryCategories },
              }}
              disabled={!hasWritePermission}
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={(e) => {
                handleDeleteOpen(flowIndex);
                e.stopPropagation();
              }}
            >
              <Delete />
            </IconButton>
            <IconButton
              onClick={(e) => {
                handleUpdateOpen(flowIndex);
                e.stopPropagation();
              }}
            >
              {!columnData["isVisible"] ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </Box>
        </fieldset>
      );
    case "tags":
      return (
        <Typography variant="body1" display="block" noWrap>
          {Array.isArray(columnData[key]) ? columnData[key].join(", ") : ""}
        </Typography>
      );
    case "createdAt":
      return (
        <Typography variant="body1" display="block" noWrap>
          {getFormattedDate(columnData[field.key])}
        </Typography>
      );
    default:
      return (
        <Typography variant="body1" display="block" noWrap>
          {columnData[field.key] || ""}
        </Typography>
      );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    overflowX: "hidden",
    // overflowY: "auto",
    // background: theme.palette.secondary.main,
    // borderRadius: "8px",
    position: "relative",
    // border: "1px solid lightgrey",
    [theme.breakpoints.down("sm")]: {
      // height: "calc(100vh - 60px)",
    },
    "& table": {
      borderCollapse: "collapse",
      borderSpacing: 0,
      width: "100%",
      // background: "pink"
    },
  },
  header: {},
  row: {
    background: "white",
    display: "flex",
    margin: "15px 0px",
    borderRadius: "8px",
    padding: "10px 10px",
    boxSizing: "border-box",
  },
  alterRow: {
    // background: "rgb(245,245,245)"
  },
  topbar: {
    background: "rgb(255,255,255)",
    padding: "0px 10px",
    cursor: "auto",
    // position: "sticky",
    // top: "0",
    // zIndex: "100"
  },
  column: {
    // width: "4400px",
    fontWeight: "normal",
    height: "50px",
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    boxSizing: "border-box",
  },
  dataColumn: {
    width: "20%",
    overflow: "hidden",
    // minHeight: "80px",
    // display: "flex",
    // background: "red"
    // flexWrap: "wrap"
    [theme.breakpoints.down("sm")]: {
      width: "180px",
      // height: "calc(100vh - 60px)",
    },
  },
  checkboxColumn: {
    width: "60px",
    // background: "red"
  },
  clickable: {
    cursor: "pointer",
    "&:hover": {
      background: "rgb(252,252,252)",
    },
  },
});

export default withStyles(styles)(FlowLibraryTable);
